import React, {Dispatch, FC, useEffect, useState} from 'react'
import {
  Column,
  DataGrid,
  HeaderFilter,
  Scrolling,
  SearchPanel,
  Summary,
  TotalItem,
  Selection,
} from 'devextreme-react/data-grid'

import {Button, Spinner} from 'react-bootstrap-v5'
import ApiCalls from '../../../../network/ApiCalls'
import {ICity} from '../../../../interfaces/Cities'
import {useDispatch} from 'react-redux'
import {DeleteActions} from '../../../../redux/actionTypes/deleteDialogTypes'
import * as deleteDialogActionCreators from '../../../../redux/actionCreators/deleteDialogActionCreators'

type Props = {
  data: ICity[]
  vendorId: number
  userId: number
  staffRefetch: () => void
}
export const StaffServicesTable: FC<Props> = ({data, vendorId, userId, staffRefetch}) => {
  const [loading, setLoading] = useState(false)
  const [selectedZipCode, setSelectedZipCode] = useState<any>([])
  const deletDialogDispatch = useDispatch<Dispatch<DeleteActions>>()

  useEffect(() => {
    setSelectedZipCode([])
  }, [])

  // try {
  //     setLoading(true)
  //     await ApiCalls.deleteStaffCityService({
  //         vendorId: vendorId,
  //         userId: userId,
  //         cityZipCodes: selectedZipCode
  //     })
  //     await staffRefetch()
  //     setLoading(false)
  // } catch (error) {
  //     setLoading(false)
  // }
  const addServiceStaffs = async () => {
    deletDialogDispatch(
      deleteDialogActionCreators.openDeleteDialog(
        async () => {
          try {
            setLoading(true)
            await ApiCalls.deleteStaffCityService({
              vendorId: vendorId,
              userId: userId,
              cityZipCodes: selectedZipCode,
            })
            await staffRefetch()
            deletDialogDispatch(deleteDialogActionCreators.closeDeleteDialog())
            setLoading(false)
          } catch (error) {
            setLoading(false)
          }
        },
        `Are you sure you want to delete staff service cities? (${selectedZipCode.length}*)`,
        'Delete Note?'
      )
    )
  }

  const onSelectionChanged = (cellValue: any) => {
    setSelectedZipCode(cellValue.selectedRowsData.map((element: any) => element.zipCode))
  }

  return (
    <>
      <h3>Staff Service Cities</h3>
      <small className='text-danger'>This table lists the cities where the staff serves. </small>
      <DataGrid
        id='ServiceCitiesTable'
        keyExpr='id'
        onRowPrepared={(e) => {
          e.rowElement.classList.add('data-grid-row')
        }}
        dataSource={data}
        showBorders={false}
        showColumnLines={false}
        showRowLines={true}
        hoverStateEnabled={true}
        height={'calc(50vh - 60px)'}
        allowColumnResizing={true}
        onSelectionChanged={onSelectionChanged}
      >
        <HeaderFilter visible={true} />
        <Selection mode='multiple' showCheckBoxesMode='always' />
        <Scrolling showScrollbar='always' mode='virtual' rowRenderingMode='virtual' />
        <SearchPanel visible={true} />
        <Summary>
          <TotalItem
            cssClass='absolute-right'
            displayFormat='Total Cities: {0}'
            column='cityName'
            summaryType='count'
          />
        </Summary>
        <Column dataField='cityName' minWidth={50} cssClass='cls' caption='CITY' />
        <Column
          dataField='stateName'
          alignment='center'
          caption='STATE'
          minWidth={150}
          cssClass='cls'
        />
        <Column
          dataField='zipCode'
          alignment='center'
          caption='ZIPCODE'
          minWidth={30}
          cssClass='cls'
        />

        <Column minWidth={20} alignment='center' dataField='' cssClass='cls' />
      </DataGrid>
      <div className='mt-5'>
        <Button
          onClick={addServiceStaffs}
          disabled={loading || selectedZipCode.length == 0}
          className={`btn-sm btn-danger w-100`}
        >
          Remove from Zone {loading && <Spinner size='sm' animation='border' />}
        </Button>
      </div>
    </>
  )
}
